import { Image } from 'antd';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { SellTractorImageUploader } from '../uploader/SellTractorImageUploader';

interface SellTractorImageUploadButtonProps {
  inputId: string;
  buttonText?: string;
  uploadedImageUrl?: string;
  successHandler: (fileUrl: string) => void;
  errorHandler: () => void;
  deleteHandler: () => void;
}

export const SellTractorImageUploadButton = ({
  inputId,
  buttonText,
  uploadedImageUrl,
  successHandler,
  errorHandler,
  deleteHandler,
}: SellTractorImageUploadButtonProps) => {
  const handleImageUploadSuccess = (fileUrl: string) => {
    successHandler(fileUrl);
  };

  const handleDeleteImageConfirm = () => {
    deleteHandler();
  };

  return (
    <Container isImageUploaded={!!uploadedImageUrl}>
      {!uploadedImageUrl ? (
        <>
          <SellTractorImageUploader
            inputId={inputId}
            successHandler={handleImageUploadSuccess}
            errorHandler={errorHandler}
          />

          <LeftSection>
            <PlusIconBackground>
              <Icon name={'Plus'} width={14} height={14} />
            </PlusIconBackground>
            <ButtonText isImageUploaded={!!uploadedImageUrl}>{buttonText}</ButtonText>
          </LeftSection>
        </>
      ) : (
        <>
          <LeftSection>
            <UploadedImage src={uploadedImageUrl} />
            <ButtonText isImageUploaded={!!uploadedImageUrl}>{buttonText}</ButtonText>
          </LeftSection>

          <RightSection>
            <DeleteButton onClick={handleDeleteImageConfirm}>
              <Icon name="CloseGreyBold" width={14.8} height={14.8} />
            </DeleteButton>
          </RightSection>
        </>
      )}
    </Container>
  );
};

const Container = styled.div<{ isImageUploaded: boolean }>`
  width: 100%;
  height: 78px;

  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 24px;
  padding-top: ${(props) => props.isImageUploaded && '12px'};
  padding-bottom: ${(props) => props.isImageUploaded && '12px'};

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const LeftSection = styled.div`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: var(--radius-large, 16px);
`;

const RightSection = styled.div`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: var(--radius-large, 16px);
`;

const UploadedImage = styled(Image)`
  min-width: 54px;
  max-width: 54px;
  min-height: 54px;
  max-height: 54px;

  display: flex;
  align-items: center;

  border-radius: var(--radius-medium, 8px);
`;

const PlusIconBackground = styled.div`
  width: 46px;
  height: 46px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-medium, 8px);

  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
`;

const ButtonText = styled.span<{ isImageUploaded: boolean }>`
  color: ${(props) => (props.isImageUploaded ? '#505363' : '#a7a9b6')};
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const DeleteButton = styled.button`
  width: 20px;
  height: 20px;

  display: flex;

  justify-content: center;
  align-items: center;

  padding: 2.6px;
`;
